export interface DateRange {
  earliest: string
  latest: string
}

export function formatDateRange(range: DateRange | null): string {
  if (!range) return ''
  
  const earliest = new Date(range.earliest)
  const latest = new Date(range.latest)
  
  if (earliest.toDateString() === latest.toDateString()) {
    return earliest.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  }
  
  if (earliest.getMonth() === latest.getMonth() && earliest.getFullYear() === latest.getFullYear()) {
    return `${earliest.toLocaleDateString('en-US', { month: 'short' })} ${earliest.getDate()}-${latest.getDate()}, ${earliest.getFullYear()}`
  }
  
  if (earliest.getFullYear() === latest.getFullYear()) {
    return `${earliest.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${latest.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}, ${earliest.getFullYear()}`
  }
  
  return `${earliest.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })} - ${latest.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`
}

export function formatShortDate(date: string): string {
  // Extract YYYY-MM-DD and construct a local-timezone date so that the
  // calendar date in the string is always displayed as-is.
  const datePart = date.split('T')[0]
  const [year, month, day] = datePart.split('-').map(Number)
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
}
